// https://v2.nuxt.com/docs/configuration-glossary/configuration-router/#scrollbehavior
export default async function (to, from, savedPosition) {
	if (savedPosition) {
		return savedPosition;
	}

	// Try to find the element every 100ms (timeout at 5 seconds)
	// This is needed when navigating to a specific element using hashes (Ex. /home#form123)
	const findEl = async (hash, x) => {
		return (
			document.querySelector(hash) ||
			new Promise((resolve) => {
				if (x > 50) {
					return resolve();
				}
				setTimeout(() => {
					resolve(findEl(hash, ++x || 1));
				}, 100);
			})
		);
	};

	if (to.hash) {
		let el = await findEl(to.hash);
		if ("scrollBehavior" in document.documentElement.style) {
			return window.scrollTo({
				top: el.offsetTop - 50,
				behavior: "smooth",
			});
		} else {
			return window.scrollTo(0, el.offsetTop);
		}
	}

	return { x: 0, y: 0 };
}
